import { Modal } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import Lottie from "lottie-react";
import animationData from "components/wizard/lottie/warning-light.json";

const ErrorClaimModal = ({ show, onClose, error }) => {
  const title = error?.message_en;

  const description = (
    <div>
      <div className="mb-1">
        {error?.data?.status === "failed"
          ? `(${error?.data?.error_code}) - ${error?.data?.error_msg} `
          : ""}
      </div>
    </div>
  );

  const handleClose = async () => {
    onClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="text-center px-4">
        <FalconCloseButton
          size="sm"
          className="position-absolute top-0 end-0 me-2 mt-2"
          onClick={handleClose}
        />

        <Lottie
          animationData={animationData}
          loop
          style={{ width: 100, height: 100, margin: "0 auto" }}
        />

        <h5 className="mt-1 text-danger fw-bold">{title}</h5>
        <div className="text-muted fs-10 mt-2">{description}</div>
      </Modal.Body>
    </Modal>
  );
};

export default ErrorClaimModal;
